import Axios from '@/axios'

// 用户登录
export const Login = data => {  
  return Axios({
    url: '/nfc-manager/admin-web/session/login',
    method: 'POST',
    type: 'json',
    data
  })
}
// 用户登出
export const Logout = data => {  
  return Axios({
    url: '/nfc-manager/admin-web/session/logout',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改密码
export const ChangePassword = data => {  
  return Axios({
    url: '/nfc-manager/admin-web/session/change_password',
    method: 'POST',
    type: 'json',
    data
  })
}
// 获取登录验证码
export const GetLoginVerifyCode = data => {  
  return Axios({
    url: '/nfc-manager/admin-web/session/get_valid_code_photo',
    method: 'POST',
    type: 'json',
    data
  })
}